import Vue from 'vue'

import dynStorage from '@/utils/storage-dynamic'

import { simsMultiPlansToDefaultSettings } from '@/helpers/sims-multi-plans'

const SIMS_MULTI_PLANS = 'sims-multi-plans'

const state = {
    sims_multi_plan: null,
    sims_multi_plans: [],
}

const getters = {
    sims_multi_plans: state => state.sims_multi_plans,

    sims_multi_plans_limit: () => parseInt(process.env.VUE_APP_SIMS_MULTI_PLANS_LIMIT) || Number.MAX_SAFE_INTEGER,
    sims_multi_plans_member_name: () => process.env.VUE_APP_SIMS_MULTI_PLANS_MEMBER_NAME == 'true',

    is_sims_multi_plans_family_allowed: () => process.env.VUE_APP_SIMS_MULTI_PLANS_FAMILY == 'true',
    is_sims_multi_plans_solo_allowed: () => true, // всегда доступна для заказа
    is_sims_multi_plans_companion_allowed: () => process.env.VUE_APP_SIMS_MULTI_PLANS_COMPANION == 'true',
    is_sims_multi_plans_allowed: (state, getters) => getters.is_sims_multi_plans_family_allowed
                                                    || getters.is_sims_multi_plans_companion_allowed,
}

const mutations = {
    simsMultiPlansSet(state, { plan, sims }) {
        let changed = false

        if (plan && plan != state.sims_multi_plan) {
            state.sims_multi_plan = plan
            changed = true
        }

        if (sims) {
            state.sims_multi_plans = sims
            changed = true
        }

        if (changed) {
            dynStorage.set(SIMS_MULTI_PLANS, {
                plan: state.sims_multi_plan,
                sims: state.sims_multi_plans,
            }, false, true)
        }
    },

    simsMultiPlansLoad(state, plan) {
        const sims_multi_plans = dynStorage.get(SIMS_MULTI_PLANS, true)
        
        state.sims_multi_plan = sims_multi_plans?.plan
        state.sims_multi_plans = simsMultiPlansToDefaultSettings(sims_multi_plans?.sims, plan, state.sims_multi_plan != plan)
    },

    simsMultiPlansReset(state) {
        state.sims_multi_plans = []

        dynStorage.remove(SIMS_MULTI_PLANS)
    },

    simMultiPlanAddon(state, { addon, index }) {
        if (index < state.sims_multi_plans.length && addon?.Availabilities?.[0]) {
            Vue.set(state.sims_multi_plans[index], 'Product', {
                ProductType: addon.ProductType,
                is_payg: addon.is_payg,
                is_autoRenew: addon.is_autoRenew,

                MobileProductAvailabilityUUID: addon.Availabilities[0]?.UUID,
                MobileProductCatalogUUID: addon.Availabilities[0]?.ProductCatalogEntryUUID,
                PriceCents: addon.Availabilities[0]?.RetailCents,
            })

            dynStorage.set(SIMS_MULTI_PLANS, {
                plan: state.sims_multi_plan,
                sims: state.sims_multi_plans,
            }, false, true)
        }
    },
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions,
}
